import { getTranslationFileForLocale } from './getTranslationFile';
const translationFile = getTranslationFileForLocale();
export const localise = (key) => translationFile[key];
export const pluralise = (value, count) => count > 1 ? `${value}s` : value;
export const templateReplace = (template, params) => Object.keys(params).reduce((acc, curr) => acc.replace(`:${curr}`, params[curr]), template);
